<template>
  <section class="container-sarah">
    <div class="align columns is-vcentered">
      <div class="colum img view-desktop">
        <img
          class="login-section_logo"
          src="~@/assets/images/banners/documents-sarah_atestados.svg"
          alt="Atestados"
        />
      </div>
      <div class="column text">
        <h3>{{ $t('documentos.atestados.subtitulo') }}</h3>
        <p>
          {{ $t('documentos.atestados.descricao') }}
        </p>

        <b-button
          class="button button-primary"
          tag="router-link"
          :to="{ name: 'Atestado' }"
        >
          {{ $t('botoes.emitir') }}
        </b-button>
      </div>
    </div>
    <!-- table of content -->
    <tablelist
      class="table"
      :data="getAtestados"
      :columns="columnsList"
      :isnt-checkable="true"
      :filter-data="true"
      @filter-date="setFilter"
    />
  </section>
</template>

<script>
import TableList from '@/components/shared/table/TableList'
import { mapActions, mapGetters } from 'vuex'
import router from '@/router'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'
import { TiposDocumentos } from '../../mixins/tipos-documentos'
import { format } from 'date-fns'

export default {
  name: 'DocumentosAtestados',
  components: { tablelist: TableList },
  data() {
    return {
      columnsList: [
        {
          field: 'date',
          label: 'Data'
        },
        {
          field: 'description',
          label: 'Descrição'
        },
        {
          field: 'id',
          label: 'Action'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      getDates: 'getDateFilter',
      getAtestados: 'getAtestados'
    })
  },
  created() {
    this.setFilter()
  },
  methods: {
    ...mapActions(['setAtestados']),
    setFilter() {
      let payload = {
        type: TiposDocumentos.Atestado,
        initDate: this.getDates.initDate,
        endDate: this.getDates.endDate
      }
      if (!payload.initDate) {
        payload.initDate = format(new Date(0), 'dd/MM/yyyy')
      }
      if (!payload.endDate) {
        payload.endDate = format(new Date(), 'dd/MM/yyyy')
      }
      this.setAtestados({ ...payload }).catch((err) => {
        if (err instanceof NotAuthenticatedError) router.push('/')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
@import '~@/assets/stylesheets/buttons';
@import '~@/assets/stylesheets/document';

.button-primary {
  height: 2.5rem;
  width: 12.5rem;
}

@media (max-width: 64rem) {
  .align {
    margin-top: 3rem;

    .img {
      margin: 0;
      display: flex;
      justify-content: center;
    }

    .text {
      padding: 0;
      margin-top: 1.5rem;
    }
  }
  .button-primary {
    width: 100%;
  }
}

@media (min-width: 64rem) {
  .align {
    padding-left: 10%;
    padding-right: 10%;
  }
}
</style>
